module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_1.08a20cef.jpg";